export enum CardSuit {
  SPADE = "SPADE",
  HEART = "HEART",
  DIAMOND = "DIAMOND",
  CLUB = "CLUB",
}

export enum CardRank {
  TWO = "two",
  THREE = "three",
  FOUR = "four",
  FIVE = "five",
  SIX = "six",
  SEVEN = "seven",
  EIGHT = "eight",
  NINE = "nine",
  TEN = "ten",
  JACK = "jack",
  QUEEN = "queen",
  KING = "king",
  ACE = "ace",
}

const suits = Object.values(CardSuit);

const cards = [
  { label: "2", name: CardRank.TWO, value: 2 },
  { label: "3", name: CardRank.THREE, value: 3 },
  { label: "4", name: CardRank.FOUR, value: 4 },
  { label: "5", name: CardRank.FIVE, value: 5 },
  { label: "6", name: CardRank.SIX, value: 6 },
  { label: "7", name: CardRank.SEVEN, value: 7 },
  { label: "8", name: CardRank.EIGHT, value: 8 },
  { label: "9", name: CardRank.NINE, value: 9 },
  { label: "10", name: CardRank.TEN, value: 10 },
  { label: "J", name: CardRank.JACK, value: 10 },
  { label: "Q", name: CardRank.QUEEN, value: 10 },
  { label: "K", name: CardRank.KING, value: 10 },
  { label: "A", name: CardRank.ACE, value: 1, altValue: 11 },
];

const fullCards = suits.map((s) => cards.map((c) => ({ ...c, suit: s }))).flat(1);

// + 1 to get card from 1 - 52 not from 0
const cardMapper = new Map(fullCards.map((card, i) => [i + 1, card]));

const calculatePossiblePointsSums = (_cards: number[]) => {
  const cardsM = _cards.map((id) => cardMapper.get(id));

  return cardsM.reduce(
    (accum, card) => {
      if (!card?.value) {
        return accum;
      }

      if (card?.altValue) {
        accum.alternative = accum.main + card.altValue;
        accum.main += card.value;

        return accum;
      }

      accum.main += card?.value;

      if (accum.alternative > 0) {
        accum.alternative += card?.value;
      }

      return accum;
    },
    { main: 0, alternative: 0 }
  );
};

const checkSplit = (_cards: number[]) => {
  if (_cards.length === 0) {
    return false;
  }

  const cardsM = _cards.map((id) => cardMapper.get(id));

  const firstElement = cardsM[0];
  return cardsM.every((element) => element?.value === firstElement?.value);
};

export { cardMapper, checkSplit, calculatePossiblePointsSums };
